import { pallette as palletteType } from '../../types/theme/pallette';
import styled from 'styled-components';

interface Props {
  theme: palletteType;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Label = styled.label`
  margin-bottom: 8px;
  color: black;
  font-size: 1rem;
  font-weight: 500;
`;

export const FormTextarea = styled.textarea`
  font-family: 'Inter', sans-serif;
  resize: none;
  background-color: ${({ theme }: Props) => theme.gray8};
  padding: 13px 24px;
  border-color: transparent;
  font-size: 1rem;
  font-weight: 300;
  border-radius: 10px;
  &:focus {
    outline-color: ${({ theme }: Props) => theme.primaryColor};
  }
  &::placeholder {
    color: ${({ theme }: Props) => theme.gray4};
  }
`;

export const ErrorText = styled.p`
  font-size: 0.875rem;
  margin: 8px 0;
  color: ${({ theme }: Props) => theme.red1};
`;
